import AdaptiveLogo from '../../../common/controls/AdaptiveLogo';
import { getCompanyImage } from '../../../common/styles/Images';
import { getDomainValueForCode, getFlexColDomainValueForCode, isEmpty, formatDesignationDisplay } from '../../../library/Core/SmartFunctions';
import { getFieldOfStudyName } from '../alumni-profile/service/student-profile-view.service';

const CardWorkingOutcome = ({ alumni, state }: { alumni: any;  state: any }) => {
    console.log(alumni, " alumni ")

    const getEducationDetails = (alumni: any) => {
        let title = '';
        let university_name = '';
        let IsPrestigiousCollege='';
        let department='';
        switch (alumni?.pursuingEducationLevelCode) {
            case 'UG':
                title = 'Pursuing UG';
                university_name=alumni.universityName
                IsPrestigiousCollege=alumni?.isPrestigiousCollege 
                department=getFieldOfStudyName(alumni.fieldOfStudyCode, state)
                break;

            case 'PG':
                title = 'Pursuing PG';
                university_name=alumni.pgUniversityName
                IsPrestigiousCollege=alumni?.pgIsPrestigiousCollege 
                department=getFieldOfStudyName(alumni.pgFieldOfStudyCode, state)
                break;

            case 'JOINED_UG':
                title = 'Joined UG';
                university_name=alumni.universityName
                IsPrestigiousCollege=alumni?.isPrestigiousCollege 
                department=getFieldOfStudyName(alumni.fieldOfStudyCode, state)
                break;

            case 'JOINED_PG':
                title = 'Joined PG';
                university_name=alumni.pgUniversityName
                IsPrestigiousCollege=alumni?.pgIsPrestigiousCollege 
                department=getFieldOfStudyName(alumni.pgFieldOfStudyCode, state)
                break;
            case 'Doctoral':
                title = 'Joined Doctoral';
                university_name=alumni.universityName
                IsPrestigiousCollege=alumni?.isPrestigiousCollege 
                department=getFieldOfStudyName(alumni.fieldOfStudyCode, state)
                break;
        }
        return (
             `<div class="alumni_univarsity_brife">
                    <div class="alumni_education text-start">${title}</div>
                    <div class="alumni_univarsity_name">
                        <span class="text-black">${university_name}</span>
                        ${IsPrestigiousCollege === '1' ? (
                            `<i class="ms-1 position-static bg-transparent">
                               <img src={"${process.env.REACT_APP_IMAGE_BASEPATH}/subtraction.svg"} />
                            </i>`
                        ) : ''}
                    </div>
                    ${!isEmpty(department) ? (
                        `<div class="alumni_univarsity_subject">
                            <i></i><span class="text-start">${department}</span>
                        </div>`
                    ) : ''}
                </div>`
        );
    };

    const getImage = (alumni: any) => {
        let flexCol;
        if (alumni?.postProgramCompletionStatusCode === 'TEACHING_AND_RESEARCH') {
            flexCol = getFlexColDomainValueForCode(alumni?.outcomeJobInstituteId, 'INSTITUTE_DOMAIN', state);
        } else {
            flexCol = getFlexColDomainValueForCode(alumni.jobCompanyId, 'COMPANY_CODE', state);
        }
        const logo = isEmpty(flexCol) ? '' : JSON.parse(flexCol).logo;
        return getCompanyImage(logo); 
    };

    const logoSrc =
        alumni?.postProgramCompletionStatusCode === 'SELF_EMPLOYED_AND_FREELANCING'
            ? (() => {
                  const flexCol = getFlexColDomainValueForCode(alumni?.outcomeJobRoleCode, 'FREELANCING_JOB_ROLE_CODE', state);
                  return getCompanyImage(isEmpty(flexCol) ? '' : JSON.parse(flexCol).img);
              })()
            : getImage(alumni);

    return (
        <div key={alumni.uuid} className="alumni_univarsity_details working">
            <div className="alumni_univarsity_details_inner_cover">
                <AdaptiveLogo
                    className="alumni_univarsity_logo"
                    src={logoSrc}
                    alt={
                        alumni?.postProgramCompletionStatusCode === 'SELF_EMPLOYED_AND_FREELANCING'
                            ? 'Freelance Logo'
                            : 'Company Logo'
                    }
                    fallbackShape="square"
                />
                <div className="alumni_univarsity_brife">
                    <div className="alumni_education">
                        <div className="row g-2">
                        <div className="col">{(alumni?.postProgramCompletionStatusCode !== 'SELF_EMPLOYED_AND_FREELANCING') ? 'Working as' : 'Credited as'}</div>
                            {(alumni?.presentEducationStatusCode === 'PURSUING_STUDIES' && alumni?.isWorking === 1 &&
                                ((alumni?.pursuingEducationLevelCode === 'PG' && !isEmpty(alumni.pgUniversityName)) ||
                                (alumni?.pursuingEducationLevelCode === 'UG' && !isEmpty(alumni.universityName)))) &&
                                    <div className="col-auto">
                                        <a
                                            href="javascript:;"
                                            className="btn-white-tooltip "
                                            data-bs-toggle="tooltip"
                                            data-bs-html="true"
                                            title=""
                                            data-bs-original-title={getEducationDetails(alumni)}>
                                            Education Status
                                        </a>
                                    </div>
                                }
                        </div>
                    </div>
                    <div className="alumni_univarsity_name">
                        <span className="d-inline-flex flex-wrap align-items-center">
                        <b className="flex-1 font-500">{
                             alumni?.postProgramCompletionStatusCode === 'TEACHING_AND_RESEARCH' 
                               ? (alumni?.outcomeJobInstituteId ? getDomainValueForCode(alumni?.outcomeJobInstituteId, 'INSTITUTE_DOMAIN', state) : alumni?.outcomeJobInstituteName) 
                                : (alumni?.outcomeJobCompanyId ? getDomainValueForCode(alumni?.outcomeJobCompanyId, 'COMPANY_CODE', state) : alumni?.outcomeJobCompanyName)
                            }</b>
                    
                        {alumni?.outcomeJobCompanyPrestigious == 1 && (
                            <i className="ms-1 position-static bg-transparent">
                                <img src={`${process.env.REACT_APP_IMAGE_BASEPATH}/subtraction.svg`} />
                            </i>
                        )}
                        {alumni?.outcomeIsCampusPlacement == 1 && (
                         <i className="icon-hat ms-1 blue-filter" data-bs-toggle="tooltip" data-bs-original-title="This was a campus placement" aria-label="This was a campus placement"></i>
                        )}    
                        </span>
                    </div>
                    {(alumni?.outcomeDesignation) && (
                        <div className="alumni_univarsity_subject">
                            <i className="icon-brifecase"></i>
                            <span>
                            {formatDesignationDisplay(alumni.outcomeDesignation, state, { workingStatusCode: alumni?.workingStatusCode })}
                            </span>
                        </div>
                    )}
                </div>
            </div>
        </div>
    );
};

export default CardWorkingOutcome;
